import { ApiError } from './httpErrors';

export class UnauthorizedError extends ApiError {
  constructor(message, data) {
    super(message, 401, data);
    this.name = 'UnauthorizedError';
  }
}

export default UnauthorizedError;
